module.exports = __webpack_public_path__ + "media/images/dotykacka-logo-b24a581865ae547bbeee0058b5570b8d.svg";